module.exports = __webpack_public_path__ + "static/media/souhoola-icon.bd7ee7c8.svg";